const getters = {
  noticeNum: state => state.notice.noticeNum,
  removedProduct: state => state.staffTemplate.removedProduct,
  deptId: state => state.orgManage.deptId,
  currentNode: state => state.orgManage.currentNode,
  orgTree: state => state.orgManage.orgTree,
  orgLoading: state => state.orgManage.orgLoading,
  currentNodeLevel: state => state.orgManage.currentNodeLevel,
  permission: state => state.orgManage.permission,
}
export default getters
